<app-container class="flex justify-center container" ngClass.xs="xs" maxWidth="516px" [noPadding]="handsetService.isXs">
  <mat-card class="card" ngClass.xs="xs">
    <div class="flex flex-col items-center">
      <h1 class="header">
        <ng-container *ngIf="verified; else notVerifiedTitle">
          Wydatek dodany prawidłowo
        </ng-container>
        <ng-template #notVerifiedTitle>
          Wydatek w weryfikacji
        </ng-template>
      </h1>
      <p class="font-medium" style="margin-top: 0">
        <ng-container *ngIf="verified; else notVerifiedDescription">
          Możesz teraz odroczyć dodany wydatek.
        </ng-container>
        <ng-template #notVerifiedDescription>
          Musimy zweryfikować dane wskazanego Dostawcy. Nastąpi to najpóźniej następnego dnia roboczego. Dostaniesz powiadomienie, kiedy to nastąpi.
        </ng-template>
      </p>
      <app-icon *ngIf="verified; else notVerifiedIcon" name="check_box" [width]="75" [height]="75"
                style="margin: 3rem"></app-icon>
      <ng-template #notVerifiedIcon>
        <app-icon name="indeterminate_check_box" [width]="75" [height]="75" style="margin: 3rem"></app-icon>
      </ng-template>
    </div>
    <div class="flex flex-col">
      <app-new-loader-button
        class="big-button button-250 self-center"
        color="accent"
        [customType]="LoaderButtonType.RAISED"
        cdkFocusInitial
        buttonType="submit"
        (buttonClick)="onShowLiability()">
        Zobacz wydatek
      </app-new-loader-button>
      <button type="button" mat-button class="self-center font-bold font-medium primary-color "
              style="width: 250px;" [routerLink]="'/liabilities/add/scan'">
        Dodaj kolejny
      </button>
    </div>
  </mat-card>
</app-container>
